import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AdminAddOn, AdminBookingsService } from '../service/admin-bookings.service';
import { AuthService } from '../service/auth.service';
import { UtilService } from '../service/util.service';
import { AppConstants } from '../AppConstants';
import { duration } from 'moment';

@Component({
  selector: 'app-book-selected-slots',
  templateUrl: './book-selected-slots.component.html',
  styleUrls: ['./book-selected-slots.component.css']
})
export class BookSelectedSlotsComponent implements OnInit, OnDestroy {
  selectedSlotsData: any;
  selectedAddOns: AdminAddOn[] = [];
  displayData = {};
  displaySelectedProducts = [];
  disableConfirmBtn = true;
  globalObject = Object;
  bookNowSubscription: Subscription;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  notes: string;
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  expiryInDays: string = "0";
  expiryInMin: string = "30";
  paymentMethod: string = "cash";
  paymentOption: string = "within";
  // For the Cash method: whether the admin is recording the cash as already "Paid" or as
  // "WaitingForPayment" (to be marked paid later). Values match the backend booking status.
  cashPaymentStatus: string = "Paid";
  discountType: string = "percentage";
  discountValue: number = null;
  tenantFees: any;
  constructor(private adminBookingSvc: AdminBookingsService, private changeDetect: ChangeDetectorRef,
    private dialogRef: MatDialogRef<BookSelectedSlotsComponent>,
    private authService: AuthService, private utilService: UtilService,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.renderSelectedSlots();
    if (!this.selectedSlotsData?.length && !this.selectedAddOns.length) {
      this.dialogRef.close();
      return;
    }
    this.loadTenantFees();
  }

  /** Fetch the tenant's fee configuration so we can show the platform fee for "Pay Now". */
  loadTenantFees() {
    const firstSlot = this.selectedSlotsData && this.selectedSlotsData[0];
    if (!firstSlot || !firstSlot.uniqueId) {
      return;
    }
    // uniqueId format: tenantId_productId_date_startTime_endTime_venueId
    const tenantId = firstSlot.uniqueId.split('_')[0];
    this.authService.getTenantFeeById(tenantId).subscribe(
      (response: any) => {
        this.tenantFees = response;
      },
      (error) => {
        console.log("Error while retrieving tenant fees", error);
      }
    );
  }

  renderSelectedSlots() {
    this.selectedSlotsData = this.adminBookingSvc.getSelectedSlotData();
    this.selectedAddOns = this.adminBookingSvc.getSelectedAddOns();
    this.displayData = {};
    //console.log("Selected Slots here ",this.selectedSlotsData  );
    if (this.selectedSlotsData && this.selectedSlotsData.length > 0) {
      this.selectedSlotsData.forEach((slotData) => {
        if (!this.displayData[slotData.productName] || !this.displayData[slotData.productName][slotData.venueName]) {
          if (!this.displayData[slotData.productName]) {
            this.displayData[slotData.productName] = {};
          }
          this.displayData[slotData.productName][slotData.venueName] = [slotData];
        } else {
          this.displayData[slotData.productName][slotData.venueName].push(slotData);
        }
      });
    }

    this.displaySelectedProducts = Object.keys(this.displayData);
    this.isReadyToBook();
    this.changeDetect.detectChanges();
  }

  getDisplayData(data) {
    return JSON.stringify(data);
  }

  getFormattedTime(timeString) {
    let formattedTime = '';
    const splitTimeString = timeString.split(':');
    let timeValue = parseInt(splitTimeString[0], 10);
    const minsValue = parseInt(splitTimeString[1], 10);

    if (timeValue >= 12) {
      if (timeValue !== 12) {
        timeValue = timeValue % 12;
      }
      if (minsValue === 0) {
        formattedTime = timeValue + ' PM';
      } else {
        formattedTime = timeValue + ':' + splitTimeString[1] + ' PM';
      }
    } else {
      if (timeValue === 0) {
        timeValue = 12;
      }
      if (minsValue === 0) {
        formattedTime = timeValue + ' AM';
      } else {
        formattedTime = timeValue + ':' + splitTimeString[1] + ' AM';
      }
    }
    return formattedTime;
  }

  getFormattedDate(dateStr) {
    const splitDateStr = dateStr.split('_');
    const dateValue = splitDateStr[1];
    const splitDateValue = dateValue.split('-');
    return splitDateValue[2] + ' ' + this.months[parseInt(splitDateValue[1], 10) - 1] + ' ' + splitDateValue[0]
  }

  confirmBooking() {
    if (this.isReadyToBook()) {
      this.disableConfirmBtn = true;
      return;
    }
    this.disableConfirmBtn = true;
    const userDetails = {
      name: this.firstName + ' ' + this.lastName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      notes: this.notes
    };

    // "Pay Now" -> create the booking in a waiting-for-payment state, then open the
    // BillDesk payment gateway right away using the returned confirmationId.
    if (this.paymentMethod === 'payNow') {
      this.confirmBookingWithPayNow(userDetails);
      return;
    }

    console.log(this.expiryInDays, this.expiryInMin);
    let expiryDuration = 0;
    const generatePaymentLink:boolean = this.paymentMethod === 'sendLink';
    if(generatePaymentLink) {
      expiryDuration = (Number(this.expiryInDays) * 24 * 60) + Number(this.expiryInMin);
    }
    // Only relevant for cash (not the payment-link flow); backend ignores it otherwise.
    const cashPaymentStatus = this.paymentMethod === 'cash' ? this.cashPaymentStatus : null;
    this.bookNowSubscription = this.adminBookingSvc.bookNow(userDetails, generatePaymentLink, expiryDuration, this.discountType, this.discountValue, cashPaymentStatus).subscribe((response: any) => {
        this.adminBookingSvc.reloadData.next({
          confirmationId: response.confirmationId,
          reloadData: true
        });
        this.adminBookingSvc.clearSelectedSlots();
        this.dialogRef.close();
    }, (error: any) => {
      this.disableConfirmBtn = false;
      console.log('Error on book now API call' + JSON.stringify(error));
      if (error.status === 400 && Array.isArray(error.error)) {
        error.error.forEach(unavailableSlot => {
          if (unavailableSlot.bookingStatus === 'Unavailable') {
            const filteredSlot = this.selectedSlotsData.find(slot => slot.uniqueId === unavailableSlot.uniqueId);
            if (filteredSlot) {
              filteredSlot.price = 'Unavailable';
            }
          }
        });
      }
    });
  }

  /**
   * "Pay Now" flow. A single call to the BillDesk initiate endpoint both creates the booking
   * (WaitingForPayment) and starts the transaction, then launches the BillDesk gateway.
   * No separate confirm-booking (/book-now/v1/booking) call is needed.
   */
  private confirmBookingWithPayNow(userDetails) {
    const request = {
      bookingRequest: this.adminBookingSvc.getBookingPayload(userDetails, true),
      addOns: this.adminBookingSvc.getAddOnBookingItems(userDetails),
      browserInfo: this.utilService.getBrowserDetails(),
      // Send the raw discount the admin entered; the backend recomputes the actual amount server-side.
      discountType: (this.discountValue != null && Number(this.discountValue) > 0) ? this.discountType : null,
      discountValue: (this.discountValue != null && Number(this.discountValue) > 0) ? Number(this.discountValue) : null
    };

    this.bookNowSubscription = this.authService.initiateBillDeskPayment(request).subscribe(
      (payResponse: any) => {
        const flowConfig = this.utilService.billDeskFlowConfig(payResponse);
        const config = {
          responseHandler: (txn) => {
            console.log("BillDesk callback status:: ", txn.status);
            if (txn.status === 111 || txn.terminal_state === 111) {
              const terminationStatus = txn.status === 111 ? txn.status : txn.terminal_state;
              this.authService.terminateBillDeskTransaction(terminationStatus, payResponse.orderId)
                .pipe(finalize(() => {
                  // Runs only after the terminate call has settled (success OR the 303 redirect,
                  // which HttpClient surfaces as an error), so the reload never races ahead of it.
                  // The BillDesk SDK invokes this handler outside Angular's zone, so run the reload
                  // inside NgZone to make change detection refresh the UI.
                  this.ngZone.run(() => {
                    // confirmationId omitted so ShowNotificationComponent (success popup) is not opened.
                    this.adminBookingSvc.reloadData.next({
                      reloadData: true
                    });
                  });
                }))
                .subscribe(
                  (res: any) => console.log('terminate response', res),
                  (err: any) => console.log('terminate settled (303 redirect expected)', err)
                );
            }
          },
          merchantLogo: "/assets/img/Logo.svg",
          flowConfig: flowConfig,
          flowType: "payments"
        };
        // Mark this as an admin-initiated payment so the shared payment-status page can
        // redirect back to the admin bookings page on success.
        this.authService.setStoredItem(AppConstants.SESSION_STORAGE_PAYMENT_SOURCE, AppConstants.PAYMENT_SOURCE_ADMIN_BOOKING);
        if (typeof (window as any).loadBillDeskSdk !== 'function') {
          this.disableConfirmBtn = false;
          alert("Payment gateway is still loading. Please try again in a few seconds.");
          return;
        }
        this.adminBookingSvc.clearSelectedSlots();
        this.utilService.launchBillDeskSdk(config);
        this.dialogRef.close();
      },
      (error: any) => {
        this.disableConfirmBtn = false;
        console.log('Error initiating BillDesk payment' + JSON.stringify(error));
        if (error.error && error.error[0] && error.error[0].bookingStatus === 'Unavailable') {
          error.error.forEach(unavailableSlot => {
            const filteredSlot = this.selectedSlotsData.find(slot => slot.uniqueId === unavailableSlot.uniqueId);
            if (filteredSlot) {
              filteredSlot.price = 'Unavailable';
            }
          });
          alert("selected slots are unavailable");
        } else {
          alert("Payment gateway failed. Please try again or after some time!!!!");
        }
      }
    );
  }

  setDiscountType(type: string) {
    this.discountType = type;
    this.isReadyToBook();
  }

  isDiscountValid(): boolean {
    const value = Number(this.discountValue);
    const maximum = this.discountType === 'percentage' ? 100 : this.getSubtotal();
    return Number.isFinite(value) && value >= 0 && value <= maximum;
  }

  onDiscountChange() {
    this.isReadyToBook();
  }

  onPaymentMethodChange() {
    if (this.paymentMethod === 'sendLink') {
      this.paymentOption = 'within';
    }
    this.isReadyToBook();
  }

  /** Sum of selected slot and add-on prices (ignores 'Unavailable' slots). */
  getSubtotal(): number {
    const addOnSubtotal = this.selectedAddOns.reduce((sum, item) => sum + item.quantity * item.unitPrice, 0);
    return this.getSlotSubtotal() + addOnSubtotal;
  }

  getSlotSubtotal(): number {
    return (this.selectedSlotsData || []).reduce((sum, slot) => {
      const price = Number(slot.price);
      return sum + (isNaN(price) ? 0 : price);
    }, 0);
  }

  /** Discount amount in Rs. derived from the selected discount type/value. */
  getDiscountAmount(): number {
    const subtotal = this.getSubtotal();
    const value = Number(this.discountValue);
    if (!this.isDiscountValid() || this.discountType === 'none' || value <= 0) {
      return 0;
    }
    let discount = 0;
    if (this.discountType === 'percentage') {
      discount = (subtotal * Math.min(value, 100)) / 100;
    } else if (this.discountType === 'absolute') {
      discount = value;
    }
    // Never discount more than the subtotal.
    return Math.min(discount, subtotal);
  }

  /**
   * End-user fee for a single slot. Mirrors the backend `getBookingFee` (end-user fee):
   * Monthly slots use the multi end-user fee, everything else uses the single end-user fee.
   */
  calculateEndUserFee(slot): number {
    if (!slot || slot.price === 'Unavailable') {
      return 0;
    }

    const isMonthly = (slot.uniqueId || '').includes('Monthly');
    return this.calculateEndUserFeeForAmount(Number(slot.price) || 0, isMonthly);
  }

  private calculateEndUserFeeForAmount(amount: number, isMonthly: boolean): number {
    if (!this.tenantFees) {
      return Math.floor((amount * 2) / 100 * 10) / 10;
    }
    const feeValue = Number(isMonthly ? this.tenantFees?.multiEndUserFee : this.tenantFees?.singleEndUserFee) || 0;
    const feeType = (isMonthly ? this.tenantFees?.multiEndUserFeeType : this.tenantFees?.singleEndUserFeeType) || '';
    let rawFee = 0;
    switch (feeType.toLowerCase()) {
      case 'percentage':
      case '%':
        rawFee = (amount * feeValue) / 100;
        break;
      case 'absolute':
        rawFee = feeValue;
        break;
      default:
        rawFee = 0;
    }
    // Floor to 1 decimal place to match the backend fee rounding.
    return Math.floor(rawFee * 10) / 10;
  }

  /** Total end-user (platform) fee for the booking. Only applies to the "Pay Now" flow. */
  getPlatformFee(): number {
    if (this.paymentMethod !== 'payNow') {
      return 0;
    }
    const slotFees = (this.selectedSlotsData || []).reduce((sum, slot) => sum + this.calculateEndUserFee(slot), 0);
    const addOnFees = this.selectedAddOns.reduce((sum, item) =>
      sum + this.calculateEndUserFeeForAmount(item.quantity * item.unitPrice, false), 0);
    return slotFees + addOnFees;
  }

  /** Payable total after applying the discount (plus platform fee when paying now). */
  getTotal(): number {
    return this.getSubtotal() - this.getDiscountAmount() + this.getPlatformFee();
  }

  removeSlot(data) {
    this.adminBookingSvc.removeFromSelectedSlots({
      uniqueId: data.uniqueId, date: data.date, dateTime: data.startTime, canRemoveSlot: true});
    this.displayData = {};
    this.displaySelectedProducts = [];
    this.renderSelectedSlots();
    if (!this.selectedSlotsData?.length && !this.selectedAddOns.length) {
      this.dialogRef.close();
    }
  }

  removeAddOn(productId: number) {
    this.adminBookingSvc.removeSelectedAddOn(productId);
    this.renderSelectedSlots();
    if (!this.selectedSlotsData?.length && !this.selectedAddOns.length) {
      this.dialogRef.close();
    }
  }

  isReadyToBook() {
    const phoneRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    var isDurationValid = true;
    if (this.paymentMethod === 'sendLink') {
      const durationMin = Number(this.expiryInMin);
      const durationDays = Number(this.expiryInDays);
      isDurationValid =
        !isNaN(durationDays) &&
        durationDays >= 0 &&
        durationDays <= 30 &&
        !isNaN(durationMin) &&
        durationMin >= 10 &&
        durationMin <= 1439;

    }
    this.disableConfirmBtn = !(
      (this.selectedSlotsData?.length > 0 || this.selectedAddOns.length > 0) &&
      this.firstName &&
      this.lastName &&
      this.email &&
      emailRegex.test(this.email) &&
      this.phoneNumber &&
      phoneRegex.test(this.phoneNumber) &&
      isDurationValid &&
      this.isDiscountValid()
    );
    return this.disableConfirmBtn;
  }

  ngOnDestroy() {
    if (this.bookNowSubscription) {
      this.bookNowSubscription.unsubscribe();
    }
  }
}
